import { columnItems } from '@/mocks/buzz';

export default function ColumnSection() {
  return (
    <section id="column" className="bg-surface scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="font-display text-3xl text-coral-500 md:text-4xl">课代表专栏</p>
            <h2 className="mt-2 text-2xl font-black leading-snug md:text-3xl">替你做好功课的深度速览</h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-ink-soft md:text-base">
              不满足于热闹，更想看懂来龙去脉？这些原创解析专栏，把前因后果一次讲清楚。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-coral-50 px-4 py-2 text-xs font-bold text-coral-600">
            <i className="ri-pen-nib-line" /> 每周更新
          </span>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-3">
          {columnItems.map((c) => (
            <article
              key={c.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-paper bg-card transition-all hover:-translate-y-1 hover:border-coral-200"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-xs font-bold text-ink">
                  {c.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="text-lg font-black leading-snug text-ink md:text-xl">{c.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-ink-soft">{c.summary}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-paper px-2.5 py-1 text-xs font-medium text-ink-soft"
                    >
                      #{t}
                    </span>
                  ))}
                </div>
                <div className="mt-5 flex items-center justify-between border-t border-paper pt-4 text-xs text-ink-muted">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-user-smile-line text-leaf-500" /> {c.author}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line" /> {c.readTime} · {c.date}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}